import { GameType } from '@/modules/promotion/type'
import { FormControl, FormField, FormItem, FormMessage } from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { Control } from 'react-hook-form'

export const GAME_TYPES = [
	GameType.SLOT,
	GameType.CASINO,
	GameType.LOTTO,
	GameType.SPORT,
	GameType.FISHING,
] as const

interface GameTypeCreditSettingsProps {
	control: Control<any>
	name: string
}

export function GameTypeCreditSettings({
	control,
	name,
}: GameTypeCreditSettingsProps) {
	return (
		<div className="space-y-6">
			<h3 className="text-xl font-semibold">
				ตั้งค่าเครดิตของประเภทเกม (คืนเมื่อลูกค้าเล่นแบบไม่ฝากโปร)
			</h3>
			{GAME_TYPES.map((gameType) => (
				<div
					key={gameType}
					className="grid grid-cols-[1fr_2fr_2fr] items-start gap-4"
				>
					<div className="pt-2">{gameType}</div>
					<FormField
						control={control}
						name={`${name}.${gameType}.creditRatio`}
						render={({ field }) => (
							<FormItem>
								<FormControl>
									<Input
										type="number"
										step="any"
										max={100}
										min={0}
										placeholder="กรอกเปอร์เซ็นต์เครดิตที่จะจ่าย (0-100%)"
										value={
											field.value !== null && field.value !== undefined
												? String(Number((field.value * 100).toFixed(4)))
												: ''
										}
										onChange={(e) => {
											const value = e.target.value
												? parseFloat(e.target.value)
												: null
											field.onChange(value !== null ? value / 100 : null)
										}}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>

					<FormField
						control={control}
						name={`${name}.${gameType}.maxCreditAmount`}
						render={({ field }) => (
							<FormItem>
								<FormControl>
									<Input
										type="number"
										placeholder="กรอกจำนวนจ่ายเครดิตสูงสุด"
										{...field}
										onChange={(e) =>
											field.onChange(
												e.target.value ? Number(e.target.value) : null,
											)
										}
									/>
								</FormControl>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>
			))}
		</div>
	)
}
